import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import RoleTable from './RoleTable';

function RoleManagement() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>Role Management</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <RoleTable />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
}

export default RoleManagement;
